document.addEventListener('DOMContentLoaded', () => {
  // Ativa os botões do accordion
  document.querySelectorAll('.np-accordion-toggle').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-id');
      npToggleProductDescriptionAccordion(id);
    });
  });

  // ✅ Aguarda levemente para garantir que o conteúdo foi renderizado
  setTimeout(() => {
    const firstButton = document.querySelector('.np-accordion-toggle');
    if (firstButton) {
      const firstId = firstButton.getAttribute('data-id');
      npToggleProductDescriptionAccordion(firstId);
    }
  }, 100); // tempo suficiente para garantir o carregamento do conteúdo
});

function npToggleProductDescriptionAccordion(id) {
  const content = document.getElementById('np-pda-content-' + id);
  const icon = document.getElementById('np-pda-icon-' + id);
  const isOpen = content.classList.contains('open');

  // Fecha todos
  document.querySelectorAll('.np-product-description-accordion__content').forEach(el => {
    el.classList.remove('open');
    el.style.maxHeight = null;
  });

  document.querySelectorAll('.np-product-description-accordion__icon').forEach(el => {
    el.classList.remove('rotate');
  });

  // Abre o clicado
  if (!isOpen) {
    content.classList.add('open');
    icon.classList.add('rotate');
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }
}